var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEllipsisIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 92.2 23.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 80.5,
    cy: 11.6,
    r: 11.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 46.1,
    cy: 11.6,
    r: 11.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 11.6,
    cy: 11.6,
    r: 11.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsisIcon);
export default __webpack_public_path__ + "static/media/ellipsis-icon.054ad6e858ce8dcf4eeb80b274d295e4.svg";
export { ForwardRef as ReactComponent };